import React from 'react';

const StarIcon = ({ color }) => {
  const colors = {
    bronze: "#CD7F32",
    silver: "#C0C0C0",
    gold: "#25ee89",
    platinum: "#E5E4E2",
    diamond: "#B9F2FF"
  };

  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className="inline-block"
    >
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={colors[color] || colors.gold}
        stroke="rgba(0,0,0,0.2)"
        strokeWidth="1"
      />
      {/* Add shine effect */}
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill="url(#shine)"
        fillOpacity="0.3"
      />
      <defs>
        <linearGradient id="shine" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="white" stopOpacity="0.8" />
          <stop offset="100%" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StarIcon;